import { v1ApiClient } from '@/services';
import type { PathParams, RequestBody } from '@/shared/api/generated';

type ImportPath = '/v1/yotpo/{yotpo_id}/import';

type ImportYotpoFeedbackParams = PathParams<ImportPath, 'post'> &
  NonNullable<RequestBody<ImportPath, 'post'>>;

/**
 * Yotpo 피드백 일회성 가져오기
 */
export const importYotpoFeedback = ({
  yotpo_id,
  start_date,
  end_date,
}: ImportYotpoFeedbackParams): Promise<void> =>
  v1ApiClient
    .post(`/yotpo/${yotpo_id}/import`, { start_date, end_date })
    .then((res) => res.data);
